import { Container, Grid, Stack, Typography } from "@mui/material";
import { useTextDomainContext } from "@/app/providers";
import React, { useContext, useState, ReactElement } from "react";
import { ResetPasswordForm } from "@/components";
import { useLocation } from "react-router";
import { AuthPageLayout } from "./components";

/**
 * ResetPassword component renders a page for resetting the user's password.
 * It displays a form where the user can enter a new password using a token from the URL.
 * After the password is reset, it shows a confirmation message.
 * @returns The reset password page component
 */
export const ResetPassword = (): ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const qParams = useLocation().search;
  const token = new URLSearchParams(qParams).get("token");

  const [resetPassword, setResetPassword] = useState<boolean>(false);

  return (
    <AuthPageLayout>
      <Container maxWidth="xs" sx={{ width: "100%" }}>
        <Grid container spacing={1} sx={{ width: "100%" }}>
          <Grid size={{ xs: 12 }}>
            {!resetPassword ? (
              <Typography
                sx={{ fontSize: 36, fontWeight: 700, color: "#27272A" }}
              >
                {gettext("Reset Your Password")}
              </Typography>
            ) : (
              <>
                <Typography
                  sx={{ fontSize: 36, fontWeight: 700, color: "#015731" }}
                >
                  {gettext("Reset Completed")}
                </Typography>

                <Typography
                  sx={{
                    pt: 1,
                    fontSize: 18,
                    fontWeight: 500,
                    color: "#52525B",
                  }}
                >
                  {gettext(
                    "You can now use your new password to sign in to your account.",
                  )}
                </Typography>
              </>
            )}
          </Grid>

          <Grid size={{ xs: 12 }}>
            <Stack
              direction="row"
              sx={{
                mb: {
                  xs: -0.5,
                  sm: 0.5,
                },
                alignItems: "baseline",
              }}
            ></Stack>
          </Grid>

          <Grid size={{ xs: 12 }}>
            <ResetPasswordForm
              token={token}
              setResetPassword={setResetPassword}
            />
          </Grid>
        </Grid>
      </Container>
    </AuthPageLayout>
  );
};
